module.exports = "/currency/assets/a4c58c5316a3448d254fe18281312ad4.jpg";